export default __webpack_public_path__ + "static/media/Patient_weight.316e0d30.svg";